import { GET_SETTINGS,SET_APP_MODE  } from "./actionTypes";
import { AppMode } from "../../constants";

// Initialize app mode from localStorage. Relax is "coming soon", so the app always opens in
// Rush (SPRINT); flip RELAX_ENABLED to bring Relax back.
export const RUSH_ENABLED = true;
export const RELAX_ENABLED = false;
const getInitialAppMode = () => {
    const savedMode = localStorage.getItem('appMode');
    if (savedMode) {
        const mode = parseInt(savedMode, 10);
        if (mode === AppMode.RELAY && !RELAX_ENABLED) return AppMode.SPRINT;
        if (mode === AppMode.SPRINT || mode === AppMode.RELAY) return mode;
    }
    return AppMode.SPRINT;
};

const initialState = {
    settings: [],
    appMode: getInitialAppMode(),
};

export default function(state = initialState, action) {
    switch (action.type) {
        case GET_SETTINGS:
            return { ...state, settings: action.payload };
        case SET_APP_MODE:
            return { ...state, appMode: action.payload };
        default:
            return state;
    }
}
